import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-update-personnel',
  templateUrl: './update-personnel.component.html',
  styleUrls: ['./update-personnel.component.css']
})
export class UpdatePersonnelComponent implements OnInit {
  title="Edit Personnel Details";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/functions/personnel-details/Update-Personnel-Details/update-personnel/update-personnel.component.ts